import { Component, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, merge, startWith, switchMap } from 'rxjs';
import { ForeCastService } from 'src/app/private/services/forecast.service';
import { TeamService } from 'src/app/private/services/teams.service';
import { UsersService } from 'src/app/private/services/users.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';


@Component({
  selector: 'app-forecast',
  templateUrl: './forecast.component.html',
  styleUrls: ['./forecast.component.scss']
})
export class ForecastComponent {

  searchQuery = new FormControl();
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @ViewChild(MatSort)
  sort!: MatSort;
  dateQuery = new FormControl();
  center_id: any;
  totalRows = 0;
  temp: any = [];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  formAction = 'Add';
  currentPage = 0;
  pageSize = 25;
  pageSizeOptions: number[] = [10, 25, 100];
  btnLoading: boolean = false;
  reloading: boolean = false;
  initialLoad: boolean = true;
  currencyCode: any;
  infoArray: any = [];
  teams: any[] = [];
  users: any[] = [];
  filterArray: any = [];
  isAdmin: boolean = false;

  displayedColumns: string[] = [
    "name",
    "forecast_type",
    "forecast_amount",
    "period_start",
    "period_end",
    "createdBy",
    "createdAt",
    "action"
  ];

  editForecastData: any;
  defaultFilter = [
    // "name",
    "forecast_type",
    "forecast_amount",
    "period_start",
    "period_end",
    // "createdBy",
    "createdAt",
    "user_id",
    "team_id",
    "created_by",
    // "user_id",
    // "team_id",
    // "createdBy_id"
    // "createdAt",
    // "priority",
    // "probability",
    // "deal_priority",
    // "next_step",
    // "pipeline",
  ]


  // info = [
  //   { key: 'name', value: 'Team / User Name' },
  //   { key: 'forecast_type', value: 'Forecast Type' },
  //   { key: 'forecast_amount', value: 'Forecast Amount' },
  //   { key: 'period_start', value: 'Period Start' },
  //   { key:'period_end',value:'Period End'},
  //   { key: 'createdBy', value: 'Created By' },
  //   { key: 'createdAt', value: 'Created At' },
  //   // { key: 'probability', value: 'Probability' },
  //   // { key: 'deal_type', value: 'Deal Type' },
  //   // {key:'Owner',value:'Deal Owner'},
  //   // { key: 'deal_priority', value: 'Deal Priority' },
  //   // { key: 'next_step', value: 'Next Step' },
  //   // { key: 'pipeline', value: 'Pipeline' },
  //   // { key: 'createdAt', value: 'Created At' },
  // ];
  constructor(
    private modalService: NgbModal,
    private localStorage: LocalStorageService,
    private api: ForeCastService,
    private userApi: UsersService,
    private toaster: ToastrService,
    private teamApi: TeamService,
    private router: Router,
    private tracker: TrackingService
  ) {
    this.isAdmin = this.localStorage.checkFullAccessForTableList(
      this.localStorage.getRole()
    );
  }

  ngAfterViewInit(): void {
    this.loadData();
    this.currencyCode = this.localStorage.getClientCurrency();
  }

  availableSearchFilters = [
    { key: 'user_id', value: 'User Name' },
    { key: 'team_id', value: 'Team Name' },
    { key: 'created_by', value: 'Created By Name' },
    { key: 'forecast_type', value: 'Forecast Type' },

  ];

  loadData() {
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
    try {

      merge(
        this.dateQuery.valueChanges,
        this.searchQuery.valueChanges,
        this.sort.sortChange,
        this.paginator.page
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            this.reloading = true;
            console.log("client_id", this.localStorage.getClientId())
            console.log("dateQuery", this.dateQuery.value)
            let param: any = {
              "page": this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
              where: {
                client_id: this.localStorage.getClientId(),
              },
              "order": {
                "col": "\"forecast\".\"updatedAt\"",
                "dir": "DESC"
              },
            }
            if (this.searchQuery.value) {

              for (let [key, value] of Object.entries(this.searchQuery.value)) {
                //console.log(`${key}: ${value}`);
                if (["user_id", "team_id", "created_by"].includes(key)) {
                  param.where[key] = value;
                }
                else if (this.defaultFilter.includes(key)) {
                  key = (key == 'assign_to') ? 'user_id' : key
                  const obj = {
                    ...param.filter,
                    [key]: value,
                  };
                  param.filter = obj;
                  // param.filter = {}
                }
              }

            }
            if (param?.filter?.forecast_id && param?.filter?.forecast_id.length > 0) {
              param.where = {
                ...param.where,
                forecast_id: param?.filter?.forecast_id
              }

              // delete from param.filter.lead_id
              delete param.filter.forecast_id
            }

            if (param?.filter?.assign_to && param?.filter?.assign_to.length > 0) {
              param.where = {
                ...param.where,
                user_id: param?.filter?.assign_to
              }

              // delete from param.filter.lead_id
              delete param.filter.user_id
              delete param.filter.assign_to
            }

            // if(!this.isAdmin){
            //   param.where = {
            //     ...param.where,
            //     user_id: this.localStorage.getUserId(),
            //   };
            // }


            return this.api
              .getAllForecast(param)
              .pipe(catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            this.reloading = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            return response?.rows;
          })
        )
        .subscribe({
          next: (data) => {
            this.dataSource = new MatTableDataSource<any>(data);
          },
          error: (e) => {
            this.initialLoad = false;
            this.reloading = false;
            console.error(e);
          },
          complete: () => {
            this.reloading = false;
            this.initialLoad = false;
          },
        });
    } catch (e) {
      this.initialLoad = false;
      this.reloading = false;
      console.error(e);
    }
  }

  reloadData() {
    this.reloading = true;
    try {
      merge()
        .pipe(
          startWith({}),
          switchMap(() => {
            this.reloading = true;

            console.log("client_id", this.localStorage.getClientId())
            let param: any = {
              "page": this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
              where: {
                client_id: this.localStorage.getClientId(),
              },
              "order": {
                "col": "\"forecast\".\"updatedAt\"",
                "dir": "DESC"
              },
            }
            if (this.searchQuery.value) {

              for (let [key, value] of Object.entries(this.searchQuery.value)) {
                //console.log(`${key}: ${value}`);
                if (["user_id", "team_id", "created_by"].includes(key)) {
                  param.where[key] = value;
                }
                else if (this.defaultFilter.includes(key)) {
                  key = (key == 'assign_to') ? 'user_id' : key
                  const obj = {
                    ...param.filter,
                    [key]: value,
                  };
                  param.filter = obj;
                  // param.filter = {}
                }
              }

            }
            if (param?.filter?.forecast_id && param?.filter?.forecast_id.length > 0) {
              param.where = {
                ...param.where,
                forecast_id: param?.filter?.forecast_id
              }

              // delete from param.filter.lead_id
              delete param.filter.forecast_id
            }

            if (param?.filter?.assign_to && param?.filter?.assign_to.length > 0) {
              param.where = {
                ...param.where,
                user_id: param?.filter?.assign_to
              }

              // delete from param.filter.lead_id
              delete param.filter.user_id
              delete param.filter.assign_to
            }

            // if (!this.isAdmin) {
            //   param.where = {
            //     ...param.where,
            //     user_id: this.localStorage.getUserId(),
            //   };
            // }

            return this.api
              .getAllForecast(param)
              .pipe(catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            console.log("response", response.length)
            return response?.rows;
          })
        )
        .subscribe({
          next: (data) => {
            this.dataSource = new MatTableDataSource<any>(data);
          },
          error: (e) => {
            this.initialLoad = false;
            this.reloading = false;
            console.error(e);
          },
          complete: () => {
            this.initialLoad = false;
            this.reloading = false;
          },
        });
    } catch (e) {
      this.initialLoad = false;
      this.reloading = false;
      console.error(e);
    }
  }

  ngOnInit() {
    this.getAllTeams();
    this.getAllUsers();
    this.filterArray = [
      { key: 'user_id', value: 'User Name' },
      { key: 'team_id', value: 'Team Name' },
      { key: 'created_by', value: 'Created By Name' },
      { key: 'forecast_type', value: 'Forecast Type' },
    ];
    // for (let index = 0; index < this.info.length; index++) {
    //   this.infoArray.push({ key: this.info[index]?.key, value: this.info[index]?.value });
    // }
  }
  searchFilter(query: any) {
    this.searchQuery.setValue(query);
  }


  getAllUsers() {
    let param = {
      client_id: this.localStorage.getClientId(),
    };
    this.userApi.findAllUsers(param).subscribe({
      next: (res: any) => {
        this.users = res || [];
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }

  getAllTeams() {
    const payload = { "client_id": this.localStorage.getClientId() };
    this.teamApi.getAllTeams(payload).subscribe(
      (res: any) => {
        this.teams = res;
      },
      (err: any) => {
        console.error(err);
      }
    )
  }


  open(content: any) {
    this.modalService.open(content, {
      size: 'lg', scrollable: true,
      centered: true
    })
  }

  openEdit(content: any, element: any) {
    this.formAction = 'Update';
    this.modalService.open(content, {
      size: 'lg', scrollable: true,
      centered: true
    })
    this.editForecastData = element;
  }

  openDeleteEvent(content: any, element: any) {
    this.modalService.open(content, {
      size: 'lg', scrollable: true,
      centered: true
    })
    this.editForecastData = element;
  }


  getUserName(element: any) {
    if (element?.team_id) {
      return element?.teamData?.name || 'N/A'
    } else {
      return element?.userData?.fname + " " + element?.userData?.lname || 'N/A'
    }
  }

  openForecast(content: any) {
    this.router.navigate(
      ['/main/forecast', content.forecast_id],
      {
        queryParams: {
          period_start: content.period_start,
          period_end: content.period_end
        }
      }
    );
  }

  handleDeleteForeCast() {
    this.btnLoading = true;
    const payload = {
      forecast_id: this.editForecastData.forecast_id
    }
    this.api.deleteForecast(payload).subscribe({
      next: (res: any) => {
        this.toaster.success('Forecast deleted successfully');
        // ✅ TRACK deletion here
        const desc = `Forecast deleted with ID: ${this.editForecastData.forecast_id}`;
        this.tracker.track("Delete", "Forecast", desc);


        this.btnLoading = false;
        this.reloadData();
        this.modalService.dismissAll();
      },
      error: (e: any) => {
        this.toaster.error('Error deleting forecast');
        this.btnLoading = false;
      }
    })
  }


}


function observableOf(arg0: null): any {
  console.log(arg0);
  throw new Error('Function not implemented.');
}
